/**
 * Enumeration for the driver creation sources.
 *
 * @readonly
 * @enum {string}
 */
export const DriverSources = Object.freeze({
    EXTERNAL_IDENTITY_PROVIDER: 'EXTERNAL_IDENTITY_PROVIDER',
    IDENTIFICATION_READER: 'IDENTIFICATION_READER',
    TACHOGRAPH: 'TACHOGRAPH',
    USER: 'USER'
})
